var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-flex"},[_c('gl-button',{attrs:{"category":"tertiary","variant":"confirm"},on:{"click":function($event){return _vm.$emit('show-closed')}}},[_vm._v("\n    "+_vm._s(_vm.buttonText)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }